const getRateActionPlan = (product, isBrochureToggleEvent, code, travelAgency,
  roomDescriptions, productsCodesAddedToBrochure) => {
  const doShowChatGPTImprovedRoomDescription = travelAgency?.settings
    ?.doShowChatGPTImprovedRoomDescription || false;

  const noAdditionalInfo = !product.additional_info;
  const hasCode = !!code;
  const isBrochureToggle = !!isBrochureToggleEvent;

  const doCallGetProductInfo = (noAdditionalInfo && hasCode)
    || (noAdditionalInfo && !hasCode && isBrochureToggle);

  const doCallEnhanceDesc = doShowChatGPTImprovedRoomDescription
    && code
    && !product?.rooms?.[0]?.htmlDescription
    && (!roomDescriptions[code] || !roomDescriptions[code].description);

  const doAddToBrochure = !productsCodesAddedToBrochure.includes(product.code)
    && isBrochureToggleEvent;

  const details = {
    doCallGetProductInfo, doCallEnhanceDesc, doAddToBrochure,
  };
  return details;
};

export default getRateActionPlan;
